export const de = {
  // Navigation
  schedule: 'Zeitplan',
  employees: 'Mitarbeiter',
  vacations: 'Urlaub & Abwesenheiten',
  holidays: 'Feiertage',
  store: 'Geschäft',
  statistics: 'Statistiken',
  export: 'Exportieren',
  mySchedule: 'Mein Zeitplan',
  
  // Common actions
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  close: 'Schließen',
  back: 'Zurück',
  next: 'Weiter',
  previous: 'Vorherige',
  search: 'Suchen',
  filter: 'Filtern',
  clear: 'Löschen',
  confirm: 'Bestätigen',
  loading: 'Laden...',
  
  // Authentication
  login: 'Anmelden',
  logout: 'Abmelden',
  username: 'Benutzername',
  password: 'Passwort',
  loginError: 'Ungültiger Benutzername oder Passwort',
  scheduleSystem: 'Zeitplan-System',
  loginWithCredentials: 'Melden Sie sich mit Ihrem Benutzernamen und Passwort an',
  loggingIn: 'Anmeldung läuft...',
  testInformation: 'Test-Informationen',
  
  // Store
  storeSelector: 'Geschäfts-Auswahl',
  selectStore: 'Wählen Sie ein Geschäft aus',
  newStore: 'Neues Geschäft',
  storeName: 'Geschäftsname',
  address: 'Adresse',
  phone: 'Telefon',
  email: 'E-Mail',
  createStore: 'Geschäft erstellen',
  editStore: 'Geschäft bearbeiten',
  deleteStore: 'Geschäft löschen',
  storeCreated: 'Geschäft erfolgreich erstellt',
  storeUpdated: 'Geschäft erfolgreich aktualisiert',
  storeDeleted: 'Geschäft erfolgreich gelöscht',
  storeSettings: 'Geschäftseinstellungen',
  weeklySchedule: 'Wochenplan',
  scheduleExceptions: 'Zeitplan-Ausnahmen',
  addException: 'Ausnahme hinzufügen',
  editScheduleException: 'Zeitplan-Ausnahme bearbeiten',
  addScheduleException: 'Zeitplan-Ausnahme hinzufügen',
  updateException: 'Ausnahme aktualisieren',
  reasonOptional: 'Grund (optional)',
  openingHours: 'Öffnungszeiten',
  noExceptionsConfigured: 'Keine Ausnahmen konfiguriert',
  date: 'Datum',
  
  // Employees
  employeeName: 'Vollständiger Name',
  weeklyLimit: 'Wochenlimit (Stunden)',
  color: 'Mitarbeiterfarbe',
  role: 'Mitarbeiterrolle',
  manager: 'Manager',
  employee: 'Mitarbeiter',
  districtManager: 'Bezirksmanager',
  employeeStartDate: 'Startdatum',
  birthday: 'Geburtsdatum',
  vacationDays: 'Urlaubstage pro Jahr',
  unavailableTimes: 'Nicht verfügbare Zeiten',
  addEmployee: 'Mitarbeiter hinzufügen',
  editEmployee: 'Mitarbeiter bearbeiten',
  deleteEmployee: 'Mitarbeiter löschen',
  employeeCreated: 'Mitarbeiter erfolgreich erstellt',
  employeeUpdated: 'Mitarbeiter erfolgreich aktualisiert',
  employeeDeleted: 'Mitarbeiter erfolgreich gelöscht',
  newEmployee: 'Neuer Mitarbeiter',
  regularEmployee: 'Regulärer Mitarbeiter',
  mainManager: 'Hauptmanager',
  uniqueUsernameForLogin: 'Eindeutiger Benutzername für Mitarbeiteranmeldung',
  passwordForLogin: 'Passwort für Mitarbeiteranmeldung',
  employeeList: 'Mitarbeiterliste',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  create: 'Erstellen',
  update: 'Aktualisieren',
  manageEmployeeInfo: 'Verwalten Sie die Informationen Ihrer Mitarbeiter',
  
  // Schedule
  week: 'Woche',
  month: 'Monat',
  day: 'Tag',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  startTime: 'Startzeit',
  endTime: 'Endzeit',
  hours: 'Stunden',
  duration: 'Dauer',
  published: 'Veröffentlichen',
  draft: 'Entwurf',
  addShift: 'Schichten erstellen',
  editShift: 'Schicht bearbeiten',
  deleteShift: 'Schicht löschen',
  copyWeek: 'Woche kopieren',
  repeatWeek: 'Wiederholen',
  deleteWeek: 'Woche löschen',
  compactMode: 'Kompakter Modus',
  normalMode: 'Normaler Modus',
  thisWeek: 'Diese Woche',
  copying: 'Kopieren...',
  clickEmployeeToCreateShift: 'Klicken Sie auf einen Mitarbeiter, um manuell eine Schicht zu erstellen',
  view24h: '24h anzeigen',
  
  // Absences
  absenceManagement: 'Abwesenheitsverwaltung',
  absenceType: 'Abwesenheitstyp',
  vacation: 'Urlaub',
  sick: 'Krankheit',
  personal: 'Persönlich',
  other: 'Andere',
  absenceStartDate: 'Startdatum',
  absenceEndDate: 'Enddatum',
  reason: 'Grund',
  status: 'Status',
  pending: 'Ausstehend',
  approved: 'Genehmigt',
  rejected: 'Abgelehnt',
  newRequest: 'Neue Anfrage',
  requestSubmitted: 'Anfrage erfolgreich eingereicht',
  remainingVacationDays: 'Verbleibende Urlaubstage',
  type: 'Typ',
  dates: 'Daten',
  days: 'Tage',
  actions: 'Aktionen',
  absenceTypeLabel: 'Abwesenheitstyp',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  employeeInfo: 'Mitarbeiterinformationen',
  requestDate: 'Anfragedatum',
  approvedBy: 'Genehmigt von:',
  rejectedBy: 'Abgelehnt von:',
  rejectionReason: 'Ablehnungsgrund:',
  manageAllAbsenceRequests: 'Alle Abwesenheitsanfragen verwalten',
  totalAbsences: 'Gesamte Abwesenheiten',
  allTypes: 'Alle Typen',
  allStatuses: 'Alle Status',
  allEmployees: 'Alle Mitarbeiter',
  requestDetails: 'Anfragedetails',
  name: 'Name',
  absenceInformation: 'Abwesenheitsinformationen',
  scheduleRestrictions: 'Zeitplan-Beschränkungen',
  shiftPendingPublication: 'Schicht wartet auf Veröffentlichung',
  shiftsPendingPublication: 'Schichten warten auf Veröffentlichung',
  defineOpeningHoursAndExceptions: 'Öffnungszeiten und Ausnahmen definieren',
  open: 'Geöffnet',
  closed: 'Geschlossen',
  opens: 'Öffnet',
  closes: 'Schließt',
  range: 'Bereich',
  addRange: 'Bereich hinzufügen',
  addAnotherRange: 'Weiteren Bereich hinzufügen',
  lastSynchronization: 'Letzte Synchronisation',
  holidayInformation: 'Feiertagsinformationen',
  nationalHolidaysSyncAutomatically: 'Nationale Feiertage werden automatisch jedes Jahr synchronisiert. Diese Tage werden automatisch als arbeitsfreie Tage in der Zeitplanung berücksichtigt.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Abdeckungs- und Arbeitslastmetriken',
  activeEmployees: 'Aktive Mitarbeiter',
  shiftsThisWeek: 'Schichten diese Woche',
  totalHours: 'Gesamtstunden',
  statisticsByEmployee: 'Statistiken nach Mitarbeiter',
  assignedHours: 'Zugewiesene Stunden',
  weeklyCap: 'Wochenlimit',
  utilization: '% Auslastung',
  busiestDay: 'Geschäftigster Tag',
  daysWithoutWeekend: 'Tage ohne Wochenende',
  
  // Export
  exportSchedules: 'Zeitpläne exportieren',
  exportPublishedSchedulesInDifferentFormats: 'Veröffentlichte Zeitpläne in verschiedenen Formaten exportieren',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'Keine veröffentlichten Zeitpläne zum Exportieren',
  
  // Additional UI elements
  newAbsenceRequest: 'Neue Abwesenheitsanfrage',
  selectEmployee: 'Mitarbeiter auswählen',
  describeAbsenceReason: 'Beschreiben Sie den Grund für die Abwesenheit...',
  submitting: 'Einreichen...',
  submitRequest: 'Anfrage einreichen',
  vacationsAndAbsences: 'Urlaub und Abwesenheiten',
  requestVacation: 'Urlaub beantragen',
  newVacationRequest: 'Neue Urlaubsanfrage',
  myVacationRequests: 'Meine Urlaubsanfragen',
  clickRequestVacationToCreateFirstRequest: 'Klicken Sie "Urlaub beantragen", um Ihre erste Anfrage zu erstellen',
  vacationManagement: 'Urlaubsverwaltung',
  vacationRequests: 'Urlaubsanfragen',
  
  // Absence Types
  sickness: 'Krankheit',
  unjustified: 'Unentschuldigte Abwesenheit',
  special: 'Sonderurlaub',
  
  // Holidays
  holidayName: 'Feiertagsname',
  holidayDate: 'Feiertagsdatum',
  addHoliday: 'Hinzufügen',
  editHoliday: 'Feiertag bearbeiten',
  automaticHolidayManagement: 'Automatische Verwaltung nationaler Feiertage',
  addCustomHoliday: 'Benutzerdefinierten Feiertag hinzufügen',
  editCustomHoliday: 'Benutzerdefinierten Feiertag bearbeiten',
  updateHoliday: 'Feiertag aktualisieren',
  nationalHolidays: 'Nationale Feiertage',
  loadingHolidays: 'Feiertage laden...',
  deleteHoliday: 'Feiertag löschen',
  
  // Statistics
  totalEmployees: 'Gesamte Mitarbeiter',
  totalShifts: 'Gesamte Schichten',
  averageHours: 'Durchschnittliche Stunden',
  coverageProblems: 'Abdeckungsprobleme',
  noProblems: 'Keine Abdeckungsprobleme erkannt',
  gap: 'Lücke',
  conflict: 'Konflikt',
  overtime: 'Überstunden',
  emptyDay: 'Keine Schichten',
  weeklyOvertime: 'Wöchentliche Überstunden',
  storeClosed: 'Geschäft geschlossen',
  
  // Export
  exportData: 'Daten exportieren',
  selectDateRange: 'Datumsbereich auswählen',
  from: 'Von',
  to: 'Bis',
  exportFormat: 'Exportformat',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Daten erfolgreich exportiert',
  
  // Configuration
  configuration: 'Konfiguration',
  language: 'Anwendungssprache',
  country: 'Land (für Feiertage)',

  // Header
  scheduleAdministrationPanel: 'Zeitplan-Verwaltungspanel',
  welcome: 'Willkommen',
  invalidDay: 'Ungültiger Tag',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Tastenkürzel',
  showHideShortcutsHelp: 'Tastenkürzel-Hilfe anzeigen/ausblenden',
  toggleDarkMode: 'Dunklen Modus umschalten',
  closeModalsAndPanels: 'Modals und Panels schließen',
  openNotificationCenter: 'Benachrichtigungszentrum öffnen',
  goToScheduleTab: 'Zur Zeitplan-Registerkarte gehen',
  goToEmployeesTab: 'Zur Mitarbeiter-Registerkarte gehen',
  goToConfigurationTab: 'Zur Konfigurations-Registerkarte gehen',
  goToStatisticsTab: 'Zur Statistiken-Registerkarte gehen',
  goToExportTab: 'Zur Export-Registerkarte gehen',
  createNewShift: 'Neue Schicht erstellen',
  saveSchedules: 'Zeitpläne speichern',
  publishSchedules: 'Zeitpläne veröffentlichen',
  navigateBetweenWeeks: 'Zwischen Wochen navigieren',
  zoomInOut: 'Hinein-/Herauszoomen',
  resetZoom: 'Zoom zurücksetzen',
  addNewEmployee: 'Neuen Mitarbeiter hinzufügen',
  searchEmployees: 'Mitarbeiter suchen',
  saveEmployee: 'Mitarbeiter speichern',
  cancelEdit: 'Bearbeitung abbrechen',
  refreshStatistics: 'Statistiken aktualisieren',
  exportStatistics: 'Statistiken exportieren',
  refreshSchedules: 'Zeitpläne aktualisieren',
  pressCtrlSlashToShowHideHelp: 'Drücken Sie Strg + /, um diese Hilfe anzuzeigen/auszublenden',

  // Keyboard Shortcut Categories
  general: 'Allgemein',
  navigation: 'Navigation',
  schedules: 'Zeitpläne',

  // Coverage Problems
  gapWithoutCoverage: 'Lücke ohne Abdeckung von',
  excessiveWorkday: 'Übermäßiger Arbeitstag',
  noShifts: 'Keine Schichten',
  excessiveWeeklyHours: 'Übermäßige Wochenstunden',
  problem: 'Problem',
  
  // Notifications
  notifications: 'Benachrichtigungen',
  noNotifications: 'Keine Benachrichtigungen',
  birthdayToday: 'Geburtstag heute',
  reviewAssignments: 'Zuweisungen überprüfen',
  verifyAllEmployeesHaveAssignedSchedules: 'Überprüfen Sie, dass alle Mitarbeiter zugewiesene Zeitpläne haben',
  notification: 'Benachrichtigung',
  
  // Errors
  error: 'Fehler',
  success: 'Erfolg',
  warning: 'Warnung',
  info: 'Information',
  required: 'Dieses Feld ist erforderlich',
  invalidDate: 'Ungültiges Datum',
  invalidTime: 'Ungültige Zeit',
  networkError: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
  
  // Confirmations
  confirmDelete: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
  confirmDeleteWeek: 'Sind Sie sicher, dass Sie alle Schichten für diese Woche löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  confirmDeleteAll: 'Sind Sie sicher, dass Sie ALLE Daten löschen möchten? Diese Aktion wird alle Geschäfte, Mitarbeiter und Schichten löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'TT/MM/JJJJ',
  
  // Days of week
  daysOfWeek: {
    monday: 'Mon',
    tuesday: 'Die',
    wednesday: 'Mit',
    thursday: 'Don',
    friday: 'Fre',
    saturday: 'Sam',
    sunday: 'Son'
  },

  // Store Management
  storeManagement: 'Geschäftsverwaltung',
  welcomeSelectStore: 'Willkommen, {name}. Wählen Sie ein Geschäft zum Verwalten aus oder erstellen Sie ein neues.',
  activeStores: 'Aktive Geschäfte',
  storeList: 'Geschäftsliste',
  generateTestData: 'Testdaten generieren',
  noStoresYet: 'Noch keine Geschäfte erstellt',
  createFirstStore: 'Erstellen Sie Ihr erstes Geschäft, um mit der Verwaltung von Zeitplänen und Mitarbeitern zu beginnen.',
  storeAddress: 'Adresse',
  storePhone: 'Telefon',
  storeEmail: 'E-Mail',
  storeNamePlaceholder: 'Z.B.: Hauptgeschäft',
  storeAddressPlaceholder: 'Z.B.: Hauptstraße 123',
  storePhonePlaceholder: 'Z.B.: +49 30 1234 5678',
  storeEmailPlaceholder: 'Z.B.: geschaeft@unternehmen.com',
  editStoreTitle: 'Geschäft bearbeiten',
  createStoreTitle: 'Neues Geschäft erstellen',
  storeNameRequired: 'Geschäftsname ist erforderlich',
  confirmDeleteStore: 'Sind Sie sicher, dass Sie das Geschäft "{storeName}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  shifts: 'Schichten',
  manageStore: 'Geschäft verwalten',

  // Date Format
  dateFormat: 'Datumsformat',
  dateFormatDDMMYYYY: 'TT/MM/JJJJ',
  dateFormatMMDDYYYY: 'MM/TT/JJJJ',
  dateFormatYYYYMMDD: 'JJJJ/MM/TT',

  // Employee Dashboard
  mySchedules: 'Meine Zeitpläne',
  welcomeEmployee: 'Willkommen, {name}',
  previousWeek: 'Vorherige Woche',
  nextWeek: 'Nächste Woche',
  thisMonth: 'Dieser Monat',
  myShifts: 'Meine Schichten',
  shiftCalendar: 'Schichtkalender',
  list: 'Liste',
  calendar: 'Kalender',
  noShiftsThisWeek: 'Sie haben keine Schichten für diese Woche zugewiesen',
  noShiftsThisMonth: 'Sie haben keine Schichten für diesen Monat zugewiesen',
  previousMonth: 'Vorheriger Monat',
  nextMonth: 'Nächster Monat',
  closeSession: 'Abmelden'
};
